export const FABRIC = "fabric";
export const BLIND = "blind";
export const SHEER = "sheer";
export const SWATCH = "swatch";